"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LogoLinked = _interopRequireDefault(require("../../Molecules/LogoLinked/LogoLinked"));
var _HeaderNav = _interopRequireDefault(require("./HeaderNav2025/HeaderNav2025"));
var _Header = require("./Header2025.style");
const Header2025 = _ref => {
  let {
    navItems = {},
    metaIcons,
    campaign = 'Comic Relief',
    donateButton = null,
    characterLimit = 60,
    showBoxShadow = false,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Header.Header2025Wrapper, Object.assign({
    navItems: true,
    showBoxShadow: showBoxShadow
  }, rest), /*#__PURE__*/_react.default.createElement(_Header.InnerWrapper, null, /*#__PURE__*/_react.default.createElement(_Header.Brand, null, /*#__PURE__*/_react.default.createElement(_LogoLinked.default, {
    campaign: campaign,
    sizeSm: "50px",
    sizeMd: "55px",
    animateRotate: true
  })), /*#__PURE__*/_react.default.createElement(_HeaderNav.default, {
    navItems: navItems,
    metaIcons: metaIcons,
    donateButton: donateButton,
    characterLimit: characterLimit
  }), /*#__PURE__*/_react.default.createElement(_Header.ButtonsAndIcons, null, /*#__PURE__*/_react.default.createElement(_Header.Header2025MetaIcons, {
    isHeader: true,
    "data-testid": "meta-icons--desktop"
  }, metaIcons), /*#__PURE__*/_react.default.createElement(_Header.DonateButtonWrapperTop, {
    "data-testid": "donate-button--desktop"
  }, donateButton))));
};
var _default = exports.default = Header2025;